import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../../core/_base/crud';
import {
  PatientInsuranceDataSource,
  ClearPatientInsuranceState,
  PatientInsuranceOnServerDeleted,
  PatientInsurancePageRequested,
} from '../../../../../../../core/lists';
import { SelectionModel } from '@angular/cdk/collections';
import { PatientInsuranceModel } from '../../../../../../../core/lists/_models/patient-insurance.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../../core/reducers';
import { merge } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddInsuranceDialogComponent } from '../add-insurance-dialog/add-insurance-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, skip, tap } from 'rxjs/operators';

@Component({
  selector: 'kt-patient-insurance',
  templateUrl: './patient-insurance.component.html',
  styleUrls: ['./patient-insurance.component.scss'],
})
export class PatientInsuranceComponent implements OnInit, OnDestroy {
  dataSource: PatientInsuranceDataSource;
  displayedColumns: string[] = [
    'insurance_no',
    'insurance_name',
    'group_no',
    'person_code',
    'priority',
    'is_active',
    'actions',
  ];
  selection = new SelectionModel<PatientInsuranceModel>(true, []);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private patientId: any;
  isReadOnly = false;
  PatientInsurancesResult: PatientInsuranceModel[] = [];
  private subscriptions: any[] = [];
  @Input() patient_id_for_task_list;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
  ) {
    if (
      this.activatedRoute.url[`_value`][1] &&
      this.activatedRoute.url[`_value`][1]?.path === 'view'
    ) {
      this.isReadOnly = true;
    }
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.patientId = this.patient_id_for_task_list ? this.patient_id_for_task_list : params.id;
      this.loadPatientInsurance();
    });
    const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.subscriptions.push({ id: 2, sub: sortSubscription });

    const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.loadPatientInsurance()))
      .subscribe();
    this.subscriptions.push({ id: 3, sub: paginatorSubscriptions });

    this.dataSource = new PatientInsuranceDataSource(this.store);
    const entitiesSubscription = this.dataSource.entitySubject
      .pipe(skip(1), distinctUntilChanged())
      .subscribe((res) => {
        this.PatientInsurancesResult = res;
      });
    this.subscriptions.push({ id: 4, sub: entitiesSubscription });
    this.loadPatientInsurance();
    if (
      this.activatedRoute.url[`_value`][1] &&
      this.activatedRoute.url[`_value`][1].path === 'view'
    ) {
      this.isReadOnly = true;
      this.isReadOnly
        ? (this.displayedColumns = [
            'insurance_no',
            'insurance_name',
            'group_no',
            'person_code',
            'priority',
            'is_active',
          ])
        : (this.displayedColumns = [
            'insurance_no',
            'insurance_name',
            'group_no',
            'person_code',
            'priority',
            'is_active',
            'actions',
          ]);
    }
  }

  private loadPatientInsurance() {
    this.selection.clear();
    const queryParams = new QueryParamsModel(
      {},
      this.sort.direction !== '' ? this.sort.direction : 'desc',
      !this.sort.active || this.sort.active === '' ? 'created' : this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
    );
    // Call request from server
    this.store.dispatch(
      new PatientInsurancePageRequested({
        page: queryParams,
        patientId: this.patientId,
      }),
    );
  }

  addInsurance(patientInsurance?, viewMode?: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px';
    dialogConfig.data = {
      patientInsurance,
      isCreate: !patientInsurance,
      patientId: this.patientId,
      isReadOnly: viewMode,
    };
    const dialogRef = this.dialog.open(AddInsuranceDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.done) {
        this.loadPatientInsurance();
      }
    });
  }

  deletePatientInsurance(patientInsurance: any) {
    const _title = 'Delete Patient Insurance';
    const _description = 'Are you sure to permanently delete this Patient Insurance?';
    const _waitDesciption = 'Patient Insurance is deleting...';

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
    const dialogRefSubscription = dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }

      this.store.dispatch(
        new PatientInsuranceOnServerDeleted({
          patientInsuranceId: patientInsurance.id,
          patientId: this.patientId,
        }),
      );
    });
    this.subscriptions.push(dialogRefSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => el.sub.unsubscribe());
    this.store.dispatch(new ClearPatientInsuranceState());
  }
  getItemCssClassByStatus(is_active = false): string {
    switch (is_active) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
  }

  getItemStatusString(is_active = false): string {
    switch (is_active) {
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
    }
  }
}
